import {FC, ReactNode} from 'react'
import {Link} from 'react-router-dom'
import clsx from 'clsx'

export type EmptyStateAction = {
  label: string
  onClick?: () => void
  // Navegação interna (renderiza um Link no lugar do botão).
  to?: string
  disabled?: boolean
  // "primary" é o CTA principal (verde sólido). "light" é a ação secundária.
  variant?: 'primary' | 'light'
}

type Props = {
  // Ícone do Bootstrap Icons (ex.: `bi-folder-plus`).
  icon?: string
  title: string
  description?: ReactNode
  actions?: EmptyStateAction[]
  // Versão para dentro de cards do dashboard (menor).
  compact?: boolean
  className?: string
}

// Estado vazio padrão do sistema (identidade nova): ícone na cor da marca, título, texto curto e
// ação. Substitui a ilustração azul do Metronic e os títulos `fs-2x` de cada tela. Os tamanhos de
// fonte são únicos (classes `.empty-state-*` em style.css), então todas as telas ficam iguais.
export const EmptyState: FC<Props> = ({
  icon = 'bi-inbox',
  title,
  description,
  actions,
  compact = false,
  className,
}) => (
  <div className={clsx('empty-state', {'empty-state-compact': compact}, className)}>
    <span className='empty-state-icon' aria-hidden='true'>
      <i className={clsx('bi', icon)}></i>
    </span>
    <h3 className='empty-state-title'>{title}</h3>
    {description && <p className='empty-state-text'>{description}</p>}
    {actions && actions.length > 0 && (
      <div className='empty-state-actions'>
        {actions.map((action) => {
          const isLight = action.variant === 'light'
          const classes = clsx(
            'btn',
            compact ? 'btn-sm' : '',
            isLight ? 'btn-light' : 'btn-primary dash-toolbar-btn-primary'
          )

          return action.to ? (
            <Link key={action.label} to={action.to} className={classes}>
              {action.label}
            </Link>
          ) : (
            <button
              key={action.label}
              type='button'
              className={classes}
              onClick={action.onClick}
              disabled={action.disabled}
            >
              {action.label}
            </button>
          )
        })}
      </div>
    )}
  </div>
)
